// Created by PeakXin on 2025/10/29.
import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import app from './modules/app'
import user from './modules/user'
import sms from './modules/sms'
import student from './modules/student'
import threeDvision from './modules/three-d-vision'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    app,
    user,
    sms,
    student,
    threeDvision
  },
  getters
})

export default store
